// modules/Lot.js
import React from 'react';
import $                  from 'jquery';
import BackButton         from '../common/BackButton';
import LotDescription     from './elements/LotDescription';
import LotImage           from './elements/LotImage';
import TitleBar           from '../common/TitleBar';
import EnquiryButton      from '../common/EnquiryButton';
import ReturnButton     from '../common/ReturnButton';
import SiteDownloadButton    from '../common/SiteDownloadButton';
import FlyerButton        from '../common/FlyerButton';
import PageLoading        from '../PageLoading';
import IndividualLotPackage  from '../house-and-land/elements/IndividualLotPackage';

var sources = require('../config.json');

class Lotplan extends React.Component {
	constructor(props) {
		super(props);

		var d = new Date();
		this.lotplan_url = sources.lotplan + '/' + this.props.params.lot + "?ts=" + d.getTime();

		this.state = {
			data: {
				lot: {},
				stage: {},
				downloads: [],
				packages: []
			},
			displaysearchbutton: false
		};

		this.receivedLotplanData    = this.receivedLotplanData.bind(this);
	}

	componentWillMount() {
		window.scrollTo(0, 0);
	}

	componentDidMount() {
		$.ajax({url:this.lotplan_url,dataType:'json'}).done(this.receivedLotplanData);
		if (this.props.location.hash === "#search") {
			let newState = this.applyHash();
			this.setState(newState);
		}
		this.viewScroll();
	}


	componentWillReceiveProps(nextProps) {
		// console.log(nextProps);
		var d = new Date();
		var lotplan_url = sources.lotplan + '/' + nextProps.params.lot + "?ts=" + d.getTime();
		$.ajax({url:lotplan_url,dataType:'json'}).done(this.receivedLotplanData);

		if (nextProps.location.hash === "#search") {
			let newState = this.applyHash();
			this.setState(newState);
		}
		this.viewScroll();

	}

	applyHash(){
		let newState = Object.assign(this.state, {
			displaysearchbutton: true
		});
		return newState;
	}


	receivedLotplanData(data, status, xhr) {
		if(typeof data.lot === 'undefined') data.lot = [];
		if(typeof data.stage === 'undefined') data.stage = [];
		if(typeof data.downloads === 'undefined') data.downloads = [];
		if(typeof data.packages === 'undefined') data.packages = [];

		let newState = Object.assign(this.state, {
			data: data
		});
		this.setState(newState);
	}

	lotDownloadBlock(downloads) {
		if (downloads.length !== 0) {
			return (
				<div>
					{/*{this.renderDownloadTitleBar()}*/}
					{downloads.map(this.lotDownloadButtons)}
				</div>
			)
		} else {
			return null;
		}
	}

	renderDownloadTitleBar() {
		return (
			<TitleBar type="uppercase" bclass="black-title-bar">Downloads for this lot</TitleBar>
		);
	}

	lotDownloadButtons(download){
		return (
			<FlyerButton bclass="lot-download-button" key={download.download_id} link={download.download_pdf}>{download.download_title}</FlyerButton>
		)
	}

	lotPackagesBlock(packages) {
		if (packages.length !== 0) {
			return (
				<div>
					<div className="lot-packages-container">{this.renderPackageTitleBar()}</div>
					{packages.map(this.renderLotPackages)}
					<div className="clear-div"/>
				</div>
			)
		} else {
			return null;
		}

	}

	renderPackageTitleBar() {
		return (
			<TitleBar type=""><strong>House and Land packages</strong></TitleBar>
		);
	}

	renderLotPackages(lotpackage) {
		return (
			<IndividualLotPackage key={lotpackage.p_id} pkdetails={lotpackage}/>
		)
	}

	viewScroll(){
		setTimeout(() => {
			document.querySelector("#Lot-Top").scrollIntoView({behavior: "smooth"});
		}, 100)
	}


	render() {
		if (typeof this.state.data.lot.lot_name !== "undefined") {
			var regText = "Please provide information regarding Lot " + this.state.data.lot.lot_name;
			return (
				<div className="App">
					<div className="outer-site-plans">
						<div className="inner-site-plans">
							<div className="LnButtonContainer">
								<BackButton link={this.state.data.stage.stage_link} bclass="stage-back-button">return to releases</BackButton>
							</div>
							<div className="LnButtonContainer" id="Lot-Top">
								<ReturnButton displaysearchbutton={this.state.displaysearchbutton}></ReturnButton>
							</div>
							<div className="clear-div"></div>
							<div className="LotDetailsContainer">
								<div id="LotDetailsListContainer">
									<LotDescription title={this.state.data.lot.lot_name} lot={this.state.data.lot} />
									<EnquiryButton bclass="lot-enquiry-button" comment={regText}>Enquire about this lot</EnquiryButton>
									<FlyerButton bclass="lot-download-button" key={this.state.data.downloads[0].download_id} link={this.state.data.downloads[0].download_pdf}>download lot flyer</FlyerButton>
								</div>
								<div id="LotImageAreaContainer">
									<LotImage alt={this.state.data.lot.lot_name}>{this.state.data.lot.lot_image}</LotImage>
								</div>
								<div className="clear-div"></div>
								<div id="LotDownloadsSection">
									<div className="lot-downloads-column">
										<SiteDownloadButton key="1" buttonlink={this.state.data.downloads[1].download_pdf}>download release plan</SiteDownloadButton>
										<SiteDownloadButton key="2" buttonlink={this.state.data.downloads[2].download_pdf}>download master plan</SiteDownloadButton>
									</div>
									<div className="lot-downloads-column">
										<SiteDownloadButton key="3" buttonlink={this.state.data.lot.local_development_plan}>download local development plan</SiteDownloadButton>
										<SiteDownloadButton key="4" buttonlink={this.state.data.lot.design_guidelines}>download design guidelines</SiteDownloadButton>
										<SiteDownloadButton key="5" buttonlink={this.state.data.lot.deposited_plan}>download deposited plans</SiteDownloadButton>
									</div>
									<div className="clear-div"></div>
								</div>
								<div className="all-ipackage-container">
									{this.lotPackagesBlock(this.state.data.packages)}
								</div>
							</div>
						</div>
					</div>
				</div>
			);
		} else {
			return (
				<PageLoading>Lot information</PageLoading>
			)
		}
	}
}

export default Lotplan;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/Lotplan.js
 **/